/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import {useMultiStyleConfig, Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {LoaderIcon} from '../custom-icons'
import PropTypes from 'prop-types'
import PageScrollLock from '../shared/ui/PageScrollLock'

const LoadingSpinner = ({
    wrapperStyles = {},
    spinnerStyles = {},
    circleStyles = {},
    isBodyLocked = false
}) => {
    const styles = useMultiStyleConfig('LoadingSpinner')

    return (
        <PageScrollLock enabled={isBodyLocked}>
            <Box {...styles.wrapper} {...wrapperStyles}>
                <Box {...styles.circle} {...circleStyles}>
                    <LoaderIcon data-testid="loading" {...styles.spinner} {...spinnerStyles} />
                </Box>
            </Box>
        </PageScrollLock>
    )
}

LoadingSpinner.propTypes = {
    wrapperStyles: PropTypes.object,
    spinnerStyles: PropTypes.object,
    circleStyles: PropTypes.object,
    isBodyLocked: PropTypes.bool
}

export default LoadingSpinner
